// extracted by mini-css-extract-plugin
module.exports = {"IconTextGroup":"IconTextGroup_IconTextGroup__3A_Vi","Header":"IconTextGroup_Header__3DLwV","Description":"IconTextGroup_Description__1uwJl"};